import React from 'react'

export const Footer = () => {
  return (
    <>
        <div className="footer">
            <p>Copyright &copy; 2023 - Universidad Internacional de la Rioja - UNIR</p>
        </div>
    </>
  )
}
